import {
  PRODUCT_MODEL_LIST_GET,
  OPERATION_LOG_LIST_GET,
  OPERATION_LOG_TYPE_LIST_GET,
  SETTING_GET,
  SETTING_LIST_GET,
  SETTING_AUTHORIZE_GET,
  SYSTEM_MODEL_LIST_GET,
  AUTHORIZE_MODEL_ALL_GET,
  SYSTEM_PUBLIC_FILE_LIST_GET,
  SYSTEM_VRESION_LIST_GET,
  SYSTEM_AREA_CODE_LIST_GET,
  SYSTEM_TARGET_BUSINESS_LIST_GET,
  SPECIAL_GROUP_LIST_GET,
  SPECIAL_USER_LIST_GET,
  SPECIAL_PERMISSION_LIST_GET,
} from "../../fetch/url";
import { get } from '../../fetch/fetch';
import { curl } from 'zh-common-modules';
import { actionTypes } from "./constants";

export const setProductModelList = data => ({
  type: actionTypes.SET_PRODUCT_MODEL_LIST,
  data
});

export const setLogList = data => ({
  type: actionTypes.SET_OPERATION_LOG_LIST,
  data
});

export const setLogTypeList = data => ({
  type: actionTypes.SET_OPERATION_LOG_TYPE_LIST,
  data
});

export const setQaContent = data => ({
  type: actionTypes.SET_QA_CONTENT,
  data
});

export const setContacts = data => ({
  type: actionTypes.SET_CONTACT_CONTENT,
  data
});

export const setLogoFile = data => ({
  type: actionTypes.SET_LOGO_FILE,
  data
});

export const setSettingList = data => ({
  type: actionTypes.SET_SETTING_LIST,
  data
});

export const setSettingAuthList = data => ({
  type: actionTypes.SET_SETTING_AUTH_LIST,
  data
});

export const setModelList = data => ({
  type: actionTypes.SET_MODEL_LIST,
  data
});

export const setPublicFileList = data => ({
  type: actionTypes.SET_PUBLIC_FILE_LIST,
  data
});

export const setSystemVersionList = data => ({
  type: actionTypes.SET_SYSTEM_VERSION_LIST,
  data,
});

export const getProductModelList = (data, cb) => {
  return dispatch => {
    get(PRODUCT_MODEL_LIST_GET,data)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setProductModelList(data));
          cb?.(data);
        }
      });
  };
};

export const getLogList = (data) => {
  return dispatch => {
    get(OPERATION_LOG_LIST_GET,data)
      .then(res => {
        if (res.success) {
          const data = {
            total: res.content.count,
            list: res.content.rows
          };
          dispatch(setLogList(data));
        }
      });
  };
};

export const getLogTypeList = () => {
  return dispatch => {
    get(OPERATION_LOG_TYPE_LIST_GET)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setLogTypeList(data));
        }
      });
  };
};

export const getQaContent = () => {
  return dispatch => {
    get(SETTING_GET,{keyword:'qa'})
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setQaContent(data));
        }
      });
  };
};

export const getLogoFile = () => {
  return dispatch => {
    get(SETTING_GET,{keyword:'companyLogo'})
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setLogoFile(data));
        }
      });
  };
};

export const getContacts = (data) => {
  return dispatch => {
    get(SETTING_GET,{keyword:'contactPerson'})
      .then(res => {
        if (res && res.success) {
          const data = res.content;
          dispatch(setContacts(data));
        }
      });
  };
};

export const getSettingList = (data, cb) => {
  return dispatch => {
    get(SETTING_LIST_GET,data)
      .then(res => {
        if (res.success) {
          const data = {
            total: res.content.total,
            list: res.content.rows
          };
          cb?.(res.content);
          dispatch(setSettingList(data));
        }
      });
  };
};

export const getSettingAuthList = (params) => {
  return dispatch => {
    curl
      .get(SETTING_AUTHORIZE_GET, params)
      .then((res) => {
        dispatch(setSettingAuthList({
          list: res.rows,
          total: res.total,
        }));
      });
  };
};

export const getModelList = (params, cb) => {
  return dispatch => {
    curl
      .get(SYSTEM_MODEL_LIST_GET, params)
      .then((res) => {
        dispatch(setModelList(res));
        cb?.(res);
      });
  };
};

export const getAuthModelList = (params, cb) => {
  return dispatch => {
    curl
      .get(AUTHORIZE_MODEL_ALL_GET, params)
      .then((res) => {
        cb?.(res);
      });
  };
};

export const getPublicFileList = (params) => {
  return dispatch => {
    curl
      .get(SYSTEM_PUBLIC_FILE_LIST_GET, params)
      .then((res) => {
        dispatch(setPublicFileList(res));
      });
  };
};

export const getSystemVersionList = (params) => {
  return dispatch => {
    curl
      .get(SYSTEM_VRESION_LIST_GET, params)
      .then((res) => {
        dispatch(setSystemVersionList(res));
      });
  };
};

/**
 * 获取区域编码列表
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getAreaCode = (params, cb) => {
  return dispatch => {
    curl
      .get(SYSTEM_AREA_CODE_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取目标业务
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getTargetBusiness = (params, cb) => {
  return dispatch => {
    curl
      .get(SYSTEM_TARGET_BUSINESS_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 特殊用户组列表获取
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSpecialGroupList = (params, cb) => {
  return dispatch => {
    curl
      .get(SPECIAL_GROUP_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 内部用户列表
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSpecialUserList = (params, cb) => {
  return dispatch => {
    curl
      .get(SPECIAL_USER_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 权限列表
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSpecialPrivilegeList = (params, cb) => {
  return dispatch => {
    curl
      .get(SPECIAL_PERMISSION_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};
